import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import authApi from '@/api/auth'
import VueCookies from 'vue-cookies'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    authUser: null,
    accessToken: null,
    isLockScreen: false,
    languages: {
      en: 1,
      kh: 2
    }
  },
  getters: {
    authenticated: state => state.accessToken !== null,
    accessToken: state => state.accessToken,
    permissionAllowCode: state =>
      state.authUser !== null ? state.authUser.permission_allow_code : null,
    permissions: state =>
      state.authUser !== null ? state.authUser.permissions : null,
    limitStringShow: state => text => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > 60 ? article.substring(0, 60) + '...' : article
      }
      return ''
    }
  },
  mutations: {
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user: authUser.user,
            permission_allow_code: authUser.permission_allow_code,
            permissions: authUser.permissions,
            counter: authUser.counter,
            sys_setting: authUser.sys_setting
          }
        )

        localStorage.setItem('authUser', JSON.stringify(state.authUser))
      } else {
        state.authUser = null
        localStorage.clear()
      }
      state.accessToken = VueCookies.get('token')
    },
    setIsLock(state, value) {
      state.isLockScreen = value
      localStorage.setItem('!z_dy#@_____00111$%!@', value)
    }
  },
  actions: {
    init({ state, commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      if (authUser) {
        commit('setAuthUser', authUser)
      }
      commit(
        'setIsLock',
        parseInt(localStorage.getItem('!z_dy#@_____00111$%!@'))
      )
    },
    login({ commit }, formData) {
      return authApi.login(formData).then(response => {
        VueCookies.set('token', response.data.access_token, 'Session').set(
          'refresh_token',
          response.data.refresh_token,
          'Session'
        )
        commit('setAuthUser', response.data)
        return Promise.resolve(response)
      })
    },
    logout({ commit }) {
      VueCookies.remove('token')
      VueCookies.remove('refresh_token')
      commit('setAuthUser', null)
    },
    companryLogo({ commit }) {
      return authApi.companryLogo().then(response => {
        return Promise.resolve(response)
      })
    }
  },
  modules
})

store.dispatch('init')

export default store
